var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"exchange-btn-wrapper"},[_c('common-btn',{class:['exchange-btn'],attrs:{"btnText":_vm.btnText,"tipsLeft":_vm.tipsLeft,"tipsText":_vm.tipsText,"animation":_vm.animation,"type":_vm.type,"hasTips":_vm.hasTips},on:{"click":_vm.toExchange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }